import { withStyles } from '@material-ui/core/styles'
import React from 'react'
import styles from './styles'

const PageWrapper = ({ children, classes }) => {
  return <div className={classes.wrapper}>{children}</div>
}

export default withStyles(styles)(PageWrapper)
